export default __webpack_public_path__ + "static/media/TRUCK11.6c9f1c0b.jpg";